import React, { useMemo } from 'react';

export function ResultColumns(event_category) {

  const breedDisplay = (row) => row.dog_data?.breed || ''; // Assume backend provides processed breed

  const formatJuniorHandlerName = (fullName = "") => {
  if (!fullName.trim()) return "";

  const parts = fullName.trim().split(/\s+/);

  // Only one name
  if (parts.length === 1) return parts[0];

  // At least two names → first + second initial + ***
  const firstName = parts[0];
  const secondName = parts[1];

  return `${firstName} ${secondName[0]}***`;
};


  const columnsByCategory = {
    'Junior Handling (Conformation)': useMemo(() => [
      { name: 'Class or Stake', selector: row => row.class, sortable: false, wrap: true, grow: 2 },
      { name: 'Junior Handler', selector: row => formatJuniorHandlerName(row.name), wrap: true },
      { name: 'Placement', selector: row => row.placement, wrap: true },
       { name: 'Points', selector: row => row.points1, wrap: true },
    ], []),
    'Junior Handling (Obedience)': useMemo(() => [
      { name: 'Class or Stake', selector: row => row.class, sortable: false, wrap: true, grow: 2 },
      { name: 'Junior Handler', selector: row => formatJuniorHandlerName(row.name), wrap: true },
      { name: 'Placement', selector: row => row.placement, wrap: true },
      { name: 'Score', selector: row => row.score, wrap: true },
       { name: 'Points', selector: row => row.points1, wrap: true },
             
    ], []),
   
  };

  return columnsByCategory[event_category] || columnsByCategory['Other'];
}

























